module.exports = __webpack_public_path__ + "static/media/plus-white.0d188312.svg";